import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import { canonical, webPageSchema } from "@/utils/seo";

export default function TermsPage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="w-full">
      <SEO
        meta={{
          title: "服務條款｜美好時光指南",
          description: "使用美好時光指南服務前，請詳閱本服務條款。",
          canonical: canonical("/terms"),
          keywords: ["服務條款", "使用條款", "美好時光指南"],
          structuredData: webPageSchema("服務條款｜美好時光指南", "使用美好時光指南服務前，請詳閱本服務條款。", "/terms"),
        }}
      />

      {/* Header */}
      <div className="w-full bg-slate-50 border-b border-slate-100">
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-3">
            服務條款
          </h1>
          <p className="text-slate-500">
            最後更新日期：2025 年 5 月 14 日
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-14">
        <div
          className={`space-y-10 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              1. 接受條款
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              當你訪問或使用美好時光指南（以下簡稱「本平台」）的任何服務時，即表示你同意並接受本服務條款的所有內容。若你不同意本服務條款，請勿使用本平台。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              2. 服務說明
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              本平台提供活動體驗資訊彙整、店家評比文章、探店指南等內容。部分文章會提供店家的官方連結供讀者參考。我們不擁有或經營這些第三方店家，僅提供資訊轉介。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              3. 使用者帳號
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed mb-3">
              使用部分功能（如收藏、評論）需要註冊帳號。你同意：
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm text-slate-600 leading-relaxed">
              <li>提供真實、準確、完整的個人資料</li>
              <li>妥善保管帳號密碼，對帳號下的所有活動負責</li>
              <li>發現帳號遭未授權使用時立即通知我們</li>
              <li>不得將帳號轉讓、出租或借予他人使用</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              4. 使用者行為規範
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed mb-3">
              使用本平台時，你同意不從事以下行為：
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm text-slate-600 leading-relaxed">
              <li>張貼或傳送任何違法、誹謗、威脅、騷擾、歧視或侵權的內容</li>
              <li>冒充他人或使用虛假身份</li>
              <li>干擾或破壞本平台的正常運作</li>
              <li>未經授權收集其他使用者的個人資料</li>
              <li>利用本平台從事商業廣告或垃圾訊息散布</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              5. 智慧財產權
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              本平台上的所有內容（包括文章、圖片、商標、標誌、設計）均受智慧財產權法保護。未經本平台書面同意，你不得複製、修改、散布、傳送或以任何商業目的使用這些內容。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              6. 免責聲明
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              本平台上的文章與評比內容，係由本平台團隊或神秘客實際體驗後撰寫，僅供參考。我們致力提供準確資訊，但不保證內容的絕對正確性。對於你因使用本平台資訊而產生的任何損失，本平台不負賠償責任，除非該損失係因本平台的故意或重大過失所導致。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              7. 第三方連結
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              本平台可能包含連結至第三方網站或服務。我們對這些第三方的內容、政策或行為不負任何責任。請你在使用這些第三方服務前，自行查閱其相關條款與政策。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              8. 條款修改
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              我們保留隨時修改本服務條款的權利。修改後的條款將公布於本頁面，並標示最新更新日期。若你繼續使用本平台，即表示你接受修改後的條款。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-3">
              9. 準據法與管轄法院
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              本服務條款以中華民國法律為準據法。因本服務條款所生之任何爭議，雙方同意以台灣台北地方法院為第一審管轄法院。
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}